module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_7042.b166673f.png";